import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";

export const getInvitations = createAsyncThunk(
  "invitations/getInvitations",
  async (args, thunkAPI) => {
    const { pageSize, pageNumber, searchQuery, eventId, status, orderBy } =
      args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/invitations`,
        method: "get",
        params: { pageSize, pageNumber, searchQuery, status, orderBy },
      });

      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar las invitaciones. Error: ",
        error
      );
    }
  }
);

export const getInvitationsById = createAsyncThunk(
  "invitations/getInvitationsById",
  async (args, thunkAPI) => {
    const { eventId, id } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/invitations/${id}`,
        method: "get",
      });
      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar las invitaciones. Error: ",
        error.response.status
      );
    }
  }
);

export const setInvitation = createAsyncThunk(
  "invitations/setInvitation",
  async (fieldData, thunkAPI) => {
    const { eventId, data } = fieldData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/invitations`,
      method: "post",
      data,
    });
    return { data: response };
  }
);

export const sendInvitation = createAsyncThunk(
  "invitations/sendInvitation",
  async (fieldData, thunkAPI) => {
    const { eventId, id } = fieldData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/invitations/${id}/send`,
      method: "post",
    });
    return { data: response };
  }
);

export const confirmInvitation = createAsyncThunk(
  "invitations/confirmInvitation",
  async (fieldData, thunkAPI) => {
    const { eventId, id } = fieldData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/invitations/${id}/confirm`,
      method: "post",
    });
    return { data: response };
  }
);

export const declineInvitation = createAsyncThunk(
  "invitations/declineInvitation",
  async (fieldData, thunkAPI) => {
    const { eventId, id } = fieldData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/invitations/${id}/decline`,
      method: "post",
    });
    return { data: response };
  }
);

export const updateInvitation = createAsyncThunk(
  "invitations/updateInvitation",
  async (args, thunkAPI) => {
    const { id, eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/invitations/${id}`,
      method: "patch",
      data,
    });
    return { data: response };
  }
);

export const invitationsSlice = createSlice({
  name: "invitations",
  initialState: {
    totalRows: 0,
    invitations: [],
    invitationsById: {},
    pendingUpdate: false,
    pendingConfirm: false,
    pendingDecline: false,
    pendingInvitations: false,
    pendingSetInvitation: false,
    pendingInvitationsById: false,
    pendingSendInvitations: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInvitations.fulfilled, (state, action) => {
        const { data } = action.payload;

        state.invitations = action.payload.data.data;
        state.pendingInvitations = false;
        state.totalRows = JSON.parse(data?.headers["x-pagination"]).totalCount;
      })
      .addCase(getInvitations.pending, (state, action) => {
        state.pendingInvitations = true;
      })
      .addCase(getInvitations.rejected, (state, action) => {
        state.pendingInvitations = false;
      })
      .addCase(getInvitationsById.fulfilled, (state, action) => {
        state.invitationsById = action.payload.data;
        state.pendingInvitationsById = false;
      })
      .addCase(getInvitationsById.pending, (state, action) => {
        state.pendingInvitationsById = true;
      })
      .addCase(getInvitationsById.rejected, (state, action) => {
        state.pendingInvitationsById = false;
      })
      .addCase(setInvitation.fulfilled, (state, action) => {
        state.pendingSetInvitation = false;
      })
      .addCase(setInvitation.pending, (state, action) => {
        state.pendingSetInvitation = true;
      })
      .addCase(setInvitation.rejected, (state, action) => {
        state.pendingSetInvitation = false;
      })
      .addCase(sendInvitation.fulfilled, (state, action) => {
        state.pendingSendInvitations = false;
      })
      .addCase(sendInvitation.pending, (state, action) => {
        state.pendingSendInvitations = true;
      })
      .addCase(sendInvitation.rejected, (state, action) => {
        state.pendingSendInvitations = false;
      })
      .addCase(declineInvitation.fulfilled, (state, action) => {
        state.pendingDecline = false;
      })
      .addCase(declineInvitation.pending, (state, action) => {
        state.pendingDecline = true;
      })
      .addCase(declineInvitation.rejected, (state, action) => {
        state.pendingDecline = false;
      })
      .addCase(confirmInvitation.fulfilled, (state, action) => {
        state.pendingConfirm = false;
      })
      .addCase(confirmInvitation.pending, (state, action) => {
        state.pendingConfirm = true;
      })
      .addCase(confirmInvitation.rejected, (state, action) => {
        state.pendingConfirm = false;
      })
      .addCase(updateInvitation.fulfilled, (state, action) => {
        state.updateInvitation = false;
      })
      .addCase(updateInvitation.pending, (state, action) => {
        state.updateInvitation = true;
      })
      .addCase(updateInvitation.rejected, (state, action) => {
        state.updateInvitation = false;
      });
  },
});

export default invitationsSlice.reducer;
